// =========================================================
// Milestone Bar — Buy 2 Get 1 Free progress indicator
// Updates the data-qty driven gamified bar, fires confetti on the
// transition into the unlocked state, and runs a daily countdown.
// =========================================================

function updateMilestoneBar(cart) {
  var bar = document.getElementById('tsc-milestone-bar');
  if (!bar) return;

  var tagEl = document.getElementById('tsc-mb-tag');
  var mainEl = document.getElementById('tsc-mb-main');
  if (!tagEl || !mainEl) return;

  var totalQuantity =
    typeof cart.item_count === 'number'
      ? cart.item_count
      : (cart.items || []).reduce(function (total, item) { return total + (item.quantity || 0); }, 0);

  var stateQty = totalQuantity;
  if (stateQty > 3) stateQty = 3;
  if (stateQty < 0) stateQty = 0;

  var previousQty = parseInt(bar.getAttribute('data-qty'), 10);
  if (isNaN(previousQty)) previousQty = stateQty;

  bar.setAttribute('data-qty', String(stateQty));
  bar.style.display = stateQty === 0 ? 'none' : 'flex';

  var ICONS = {
    target: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="1"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="9"/></svg>',
    flame: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 12c-2 -2.96 0 -7 1 -8c0 3.038 1.773 4.741 3 6c1.226 1.26 2 3.24 2 5a6 6 0 1 1 -12 0c0 -1.532 1.056 -3.94 2 -5c1.786 3 2.791 3 4 2z"/></svg>',
    confetti: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 5h2"/><path d="M5 4v2"/><path d="M11.5 4l-.5 2"/><path d="M18 5h2"/><path d="M19 4v2"/><path d="M15 9l-1 1"/><path d="M18 13l2 -.5"/><path d="M18 19h2"/><path d="M19 18v2"/><path d="M14 16.518l-6.518 -6.518l-4.39 9.58a1.003 1.003 0 0 0 1.329 1.329l9.579 -4.39z"/></svg>'
  };

  if (stateQty === 1) {
    tagEl.innerHTML = ICONS.target + '<span>level 1 of 3</span>';
    mainEl.innerHTML = 'Add <em>1 more</em> to claim your FREE item';
  } else if (stateQty === 2) {
    tagEl.innerHTML = ICONS.flame + '<span>level 2 of 3 — so close</span>';
    mainEl.innerHTML = 'Just <em>1 more</em> — your 3rd is FREE!';
  } else if (stateQty >= 3) {
    tagEl.innerHTML = ICONS.confetti + '<span>reward unlocked</span>';
    mainEl.innerHTML = '🏆 Buy 2 Get 1 FREE <em>activated</em>';
    if (previousQty < 3 && typeof window.confetti === 'function') {
      fireTscConfetti();
    }
  }
}

function fireTscConfetti() {
  if (typeof window.confetti !== 'function') return;
  var canvas = document.getElementById('tsc-confetti-canvas');
  if (!canvas) return;
  var rect = canvas.getBoundingClientRect();
  canvas.width = Math.max(1, rect.width);
  canvas.height = Math.max(1, rect.height);
  try {
    var myConfetti = window.confetti.create(canvas, { resize: true, useWorker: false });
    myConfetti({
      particleCount: 90,
      spread: 75,
      startVelocity: 32,
      origin: { y: 0.4 },
      colors: ['#0e4398', '#c5e42c', '#fffdc6', '#9abbf1', '#ffffff']
    });
  } catch (e) { /* noop */ }
}

(function tscStartCountdown() {
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function tick() {
    var spans = document.querySelectorAll('[data-tsc-countdown]');
    if (!spans.length) return;
    var now = new Date();
    var end = new Date(now);
    end.setHours(23, 59, 59, 0);
    var diff = Math.max(0, end - now);
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    var text = 'ends in ' + pad(h) + ':' + pad(m) + ':' + pad(s);
    for (var i = 0; i < spans.length; i++) spans[i].textContent = text;
  }
  tick();
  setInterval(tick, 1000);
})();


class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        document.dispatchEvent(new CustomEvent("cart:updated", {
  detail: { cart: parsedState }
}));

        updateMilestoneBar(parsedState);


        document.dispatchEvent(new CustomEvent("cart:updated", {
  detail: { cart: parsedState }
}));


      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );


}

document.addEventListener('DOMContentLoaded', () => {
  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => updateMilestoneBar(cart));

});

document.addEventListener("cart:updated", function(event) {
  updateMilestoneBar(event.detail.cart);
});


/* =========================================================
   TSC Cart Upsell — "Pick & Add" web component
   ========================================================= */
if (!customElements.get('tsc-cart-upsell')) {
  class TscCartUpsell extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      const button = event.target.closest('.tsc-upsell__add-btn');
      if (!button || button.hasAttribute('disabled') || button.classList.contains('is-loading')) return;
      event.preventDefault();
      this.addVariantToCart(button);
    }

    async addVariantToCart(button) {
      const variantId = button.dataset.variantId;
      if (!variantId) return;

      const cartDrawer = document.querySelector('cart-drawer');
      const sectionsToRender = ['cart-drawer', 'cart-icon-bubble'];

      const originalLabel = button.querySelector('.tsc-upsell__add-label');
      const originalLabelText = originalLabel ? originalLabel.textContent : '';

      button.classList.add('is-loading');
      if (originalLabel) originalLabel.textContent = 'Adding…';

      try {
        const response = await fetch((typeof routes !== 'undefined' && routes.cart_add_url) ? routes.cart_add_url : '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections: sectionsToRender,
            sections_url: window.location.pathname
          })
        });
        if (!response.ok) throw new Error('Add to cart failed: ' + response.status);
        const result = await response.json();
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(result);
          if (typeof cartDrawer.open === 'function') cartDrawer.open();
        } else {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: result } }));
        }
        fetch('/cart.js').then(r => r.json()).then(cart => {
          updateMilestoneBar(cart);
          if (typeof tscEnforceB2G1 === 'function') tscEnforceB2G1(cart);
        }).catch(() => {});
        button.classList.remove('is-loading');
        button.classList.add('is-added');
        if (originalLabel) originalLabel.textContent = 'Added';
        setTimeout(() => {
          if (originalLabel) originalLabel.textContent = originalLabelText;
          button.classList.remove('is-added');
        }, 1500);
      } catch (err) {
        console.error('[TSC upsell] add failed:', err);
        button.classList.remove('is-loading');
        if (originalLabel) originalLabel.textContent = originalLabelText;
      }
    }
  }
  customElements.define('tsc-cart-upsell', TscCartUpsell);
}



/* =========================================================
   TSC minus-at-1 removes item
   When a customer presses the minus button on a cart line at
   quantity 1, remove that line entirely (rather than letting
   Dawn cap it at qty 1 or move to qty 0 inconsistently).
   Uses capture phase to intercept before Dawn's quantity-input.
   ========================================================= */
document.addEventListener('click', function (event) {
  var minusBtn = event.target.closest('cart-drawer .cart-quantity .quantity__button[name="minus"], #CartDrawer .cart-quantity .quantity__button[name="minus"]');
  if (!minusBtn) return;
  var input = minusBtn.parentElement ? minusBtn.parentElement.querySelector('.quantity__input') : null;
  if (!input) return;
  var current = parseInt(input.value, 10);
  if (isNaN(current) || current !== 1) return;

  // Stop Dawn's quantity-input from handling this and find the matching remove button.
  event.preventDefault();
  event.stopPropagation();
  if (typeof event.stopImmediatePropagation === 'function') {
    event.stopImmediatePropagation();
  }

  var row = minusBtn.closest('tr.cart-item, .cart-item');
  if (!row) return;
  var removeBtn = row.querySelector('cart-remove-button button, .cart-remove-button');
  if (removeBtn) removeBtn.click();
}, true);



/* =========================================================
   TSC B2G1 auto-fulfillment
   - 2 items, single line (same variant qty=2): after 1.5s,
     auto-add 1 more of that variant + toast
   - 2 items, multiple lines (different variants): open
     blocking modal forcing customer to pick the free 3rd item
   - Block checkout when item_count === 2
   ========================================================= */
var __tscModalEl = null;
var __tscAutoAddTimer = null;
var __tscAutoAddInFlight = false;
var __tscFreeRemoveInFlight = false;
// Suppression tracking: once user reduces qty or dismisses the modal,
// we must NOT re-trigger the B2G1 auto-add for this cart. Persisted in
// sessionStorage keyed by cart.token so it survives page reloads within
// the same session and resets when a new cart is created.
var __tscPrevItemCount = null;
var __tscPrevCartToken = null;

function tscSuppressKey(token) { return 'tsc_b2g1_suppress_' + token; }
function tscDeliveredKey(token) { return 'tsc_b2g1_delivered_' + token; }

function tscIsSuppressedForThisCart(cart) {
  try {
    if (!cart || !cart.token) return false;
    return sessionStorage.getItem(tscSuppressKey(cart.token)) === '1';
  } catch (e) { return false; }
}

function tscSuppressForThisCart(cart) {
  try {
    if (!cart || !cart.token) return;
    sessionStorage.setItem(tscSuppressKey(cart.token), '1');
  } catch (e) {}
}

function tscWasBonusDelivered(cart) {
  try {
    if (!cart || !cart.token) return false;
    return sessionStorage.getItem(tscDeliveredKey(cart.token)) === '1';
  } catch (e) { return false; }
}

function tscMarkBonusDelivered(cart) {
  try {
    if (!cart || !cart.token) return;
    sessionStorage.setItem(tscDeliveredKey(cart.token), '1');
  } catch (e) {}
}

function tscClearSuppressionIfNewCart(cart) {
  try {
    if (!cart || !cart.token) return;
    if (__tscPrevCartToken && __tscPrevCartToken !== cart.token) {
      sessionStorage.removeItem(tscSuppressKey(__tscPrevCartToken));
      sessionStorage.removeItem(tscDeliveredKey(__tscPrevCartToken));
    }
    __tscPrevCartToken = cart.token;
  } catch (e) {}
}

function tscDismissB2G1() {
  // User clicked skip or close X -> remember this choice for the cart.
  if (__tscPrevCartToken) {
    try { sessionStorage.setItem(tscSuppressKey(__tscPrevCartToken), '1'); } catch (e) {}
  }
  tscCloseB2G1Modal();
}

function tscShowToast(message) {
  var t = document.createElement('div');
  t.className = 'tsc-toast';
  t.textContent = message;
  document.body.appendChild(t);
  requestAnimationFrame(function () { t.classList.add('is-visible'); });
  setTimeout(function () {
    t.classList.remove('is-visible');
    setTimeout(function () { t.remove(); }, 300);
  }, 3200);
}

function tscReadVariantData() {
  var upsell = document.querySelector('tsc-cart-upsell');
  if (!upsell) return [];
  var cards = upsell.querySelectorAll('.tsc-upsell__card');
  return Array.prototype.map.call(cards, function (card) {
    var btn = card.querySelector('.tsc-upsell__add-btn');
    var img = card.querySelector('.tsc-upsell__image');
    var nameEl = card.querySelector('.tsc-upsell__name');
    var priceEl = card.querySelector('.tsc-upsell__price');
    return {
      variantId: btn ? btn.dataset.variantId : null,
      name: nameEl ? nameEl.textContent.trim() : '',
      price: priceEl ? priceEl.textContent.trim() : '',
      img: img ? img.src : '',
      available: btn ? !btn.hasAttribute('disabled') : false
    };
  }).filter(function (v) { return v.variantId && v.available; });
}

function tscOpenB2G1Modal() {
  // Reset stale reference if the modal element was removed from DOM somehow
  if (__tscModalEl && !document.body.contains(__tscModalEl)) {
    __tscModalEl = null;
    document.body.classList.remove('tsc-b2g1-open');
  }
  if (__tscModalEl) return;
  var variants = tscReadVariantData();
  if (!variants.length) return;

  var overlay = document.createElement('div');
  overlay.className = 'tsc-b2g1-modal';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');
  overlay.setAttribute('aria-labelledby', 'tsc-b2g1-title');

  var cardsHtml = variants.map(function (v) {
    return '<button type="button" class="tsc-b2g1-modal__choice" data-variant-id="' + v.variantId + '">' +
             '<span class="tsc-b2g1-modal__img-wrap"><img class="tsc-b2g1-modal__img" alt="" src="' + v.img + '"></span>' +
             '<span class="tsc-b2g1-modal__name">' + v.name + '</span>' +
             '<span class="tsc-b2g1-modal__price"><s>' + v.price + '</s><b>FREE</b></span>' +
             '<span class="tsc-b2g1-modal__cta">Pick this FREE</span>' +
           '</button>';
  }).join('');

  overlay.innerHTML =
    '<div class="tsc-b2g1-modal__backdrop"></div>' +
    '<div class="tsc-b2g1-modal__card">' +
      '<button type="button" class="tsc-b2g1-modal__close" aria-label="Close">×</button>' +
      '<h3 id="tsc-b2g1-title" class="tsc-b2g1-modal__title">🎁 Pick your FREE 3rd item</h3>' +
      "<p class=\"tsc-b2g1-modal__subtitle\">You\'re 1 item away from Buy 2 Get 1 FREE. Choose any variant below \u2014 it\'s on us.</p>" +
      '<div class="tsc-b2g1-modal__grid">' + cardsHtml + '</div>' +
      '<button type="button" class="tsc-b2g1-modal__skip">I don\'t want the free item</button>' +
    '</div>';

  document.body.appendChild(overlay);
  __tscModalEl = overlay;
  document.body.classList.add('tsc-b2g1-open');

  overlay.querySelectorAll('.tsc-b2g1-modal__choice').forEach(function (btn) {
    btn.addEventListener('click', function () {
      tscAddVariantThenCloseModal(btn.dataset.variantId, btn);
    });
  });
  var closeBtn = overlay.querySelector('.tsc-b2g1-modal__close');
  if (closeBtn) closeBtn.addEventListener('click', tscDismissB2G1);
  var skipBtn = overlay.querySelector('.tsc-b2g1-modal__skip');
  if (skipBtn) skipBtn.addEventListener('click', tscDismissB2G1);
}

function tscCloseB2G1Modal() {
  if (!__tscModalEl) return;
  __tscModalEl.remove();
  __tscModalEl = null;
  document.body.classList.remove('tsc-b2g1-open');
}

function tscAddVariantThenCloseModal(variantId, sourceBtn) {
  if (!variantId) return;
  if (sourceBtn) {
    sourceBtn.classList.add('is-loading');
    sourceBtn.disabled = true;
  }
  fetch((typeof routes !== 'undefined' && routes.cart_add_url) ? routes.cart_add_url : '/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
    body: JSON.stringify({
      items: [{ id: variantId, quantity: 1 }],
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    })
  })
  .then(function (r) { return r.json(); })
  .then(function (result) {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents(result);
    }
    tscCloseB2G1Modal();
    // After modal-pick, record new item_count AND mark bonus delivered.
    // Reduction-detection now only suppresses post-delivery, so an honest
    // first-time modal still pops for a fresh multi-variant cart.
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (cart && typeof cart.item_count === 'number') __tscPrevItemCount = cart.item_count;
      if (cart && cart.token) __tscPrevCartToken = cart.token;
      tscMarkBonusDelivered(cart);
      updateMilestoneBar(cart);
    });
    tscShowToast('🎉 Your free item was added!');
  })
  .catch(function () {
    if (sourceBtn) {
      sourceBtn.classList.remove('is-loading');
      sourceBtn.disabled = false;
    }
  });
}

function tscEnforceB2G1(cart) {
  if (!cart || typeof cart.item_count !== 'number') return;
  // While an auto add/remove we triggered is in flight, ignore the duplicate
  // cart:updated events (updateQuantity dispatches it twice) to avoid loops.
  if (__tscAutoAddInFlight || __tscFreeRemoveInFlight) return;

  var prevTotal = __tscPrevItemCount;
  var total = cart.item_count;

  // Fresh-start path: empty cart -> clear flags so the gift can trigger again.
  if (total === 0) {
    try {
      if (cart.token) {
        sessionStorage.removeItem(tscSuppressKey(cart.token));
        sessionStorage.removeItem(tscDeliveredKey(cart.token));
      }
    } catch (e) {}
    __tscPrevItemCount = 0;
    __tscPrevCartToken = cart.token || __tscPrevCartToken;
    tscCloseB2G1Modal();
    return;
  }

  tscClearSuppressionIfNewCart(cart);

  if (__tscAutoAddTimer) {
    clearTimeout(__tscAutoAddTimer);
    __tscAutoAddTimer = null;
  }

  // Below the qualifying threshold -> clear any "declined" flag so the gift can
  // be offered again later, and ensure no stale modal is open.
  if (total < 2) {
    try { if (cart.token) sessionStorage.removeItem(tscSuppressKey(cart.token)); } catch (e) {}
    __tscPrevItemCount = total;
    tscCloseB2G1Modal();
    return;
  }

  var lines = cart.items || [];
  var freeLines = lines.filter(function (i) {
    return i.final_line_price === 0 && i.original_line_price > 0;
  });

  // Gift already present (Shopify creates the $0 line at 3+ units) -> done.
  if (freeLines.length) {
    __tscPrevItemCount = total;
    tscCloseB2G1Modal();
    return;
  }

  // Only the exact 2-unit boundary needs a decision.
  if (total !== 2) {
    __tscPrevItemCount = total;
    tscCloseB2G1Modal();
    return;
  }

  // Customer explicitly declined the gift (removed the free line / skipped modal).
  if (tscIsSuppressedForThisCart(cart)) {
    __tscPrevItemCount = total;
    tscCloseB2G1Modal();
    return;
  }

  var cameDown = (prevTotal !== null && prevTotal >= 3);

  // Dropped from a gifted (3+) state down to 2 units: the customer reduced a
  // paying item and no longer qualifies. Remove one unit of the cheapest line
  // (always the ex-gift, single- or multi-variant) so the cart settles at a
  // single paid unit -- instead of re-gifting or reopening the pick-a-gift modal.
  // The in-flight guard at the top stops the duplicate cart:updated from reacting.
  if (cameDown) {
    var cheapest = lines[0];
    for (var ci = 1; ci < lines.length; ci++) {
      if ((lines[ci].original_price || 0) < (cheapest.original_price || 0)) cheapest = lines[ci];
    }
    __tscFreeRemoveInFlight = true;
    __tscPrevItemCount = total;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({
        id: cheapest.key,
        quantity: Math.max(0, (cheapest.quantity || 1) - 1),
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
    .then(function (r) { return r.json(); })
    .then(function (result) {
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(result);
      }
      if (result && typeof result.item_count === 'number') __tscPrevItemCount = result.item_count;
      updateMilestoneBar(result);
    })
    .finally(function () { __tscFreeRemoveInFlight = false; });
    return;
  }

  // Reached 2 by adding / increasing -> gift the free item.
  __tscPrevItemCount = total;

  var singleLineTwo = (lines.length === 1 && lines[0].quantity === 2);
  if (singleLineTwo) {
    __tscAutoAddInFlight = true;
    var variantId = lines[0].variant_id;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
    .then(function (r) { return r.json(); })
    .then(function (result) {
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(result);
      }
      tscShowToast('\U0001F381 We added your free 3rd item!');
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        if (c && typeof c.item_count === 'number') __tscPrevItemCount = c.item_count;
        if (c && c.token) __tscPrevCartToken = c.token;
        tscMarkBonusDelivered(c);
        updateMilestoneBar(c);
      });
    })
    .finally(function () { __tscAutoAddInFlight = false; });
    return;
  }

  // Multi-variant (two different products) -> let the customer pick the free item.
  tscOpenB2G1Modal();
}

document.addEventListener('cart:updated', function (event) {
  if (event && event.detail && event.detail.cart) {
    tscEnforceB2G1(event.detail.cart);
  } else {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(tscEnforceB2G1);
  }
});

document.addEventListener('DOMContentLoaded', function () {
  fetch('/cart.js').then(function (r) { return r.json(); }).then(tscEnforceB2G1);
});

document.addEventListener('click', function (event) {
  var btn = event.target.closest('#CartDrawer-Checkout, .cart__checkout-button, button[name="checkout"]');
  if (!btn) return;
  // Gift already in cart -> allow checkout.
  if (document.querySelector('cart-drawer-items .tsc-free-item, cart-items .tsc-free-item')) return;
  // Customer explicitly declined the gift -> allow checkout.
  var declined = false;
  try { if (__tscPrevCartToken) declined = sessionStorage.getItem(tscSuppressKey(__tscPrevCartToken)) === '1'; } catch (e) {}
  if (declined) return;
  // Otherwise count paid quantity (free row has no quantity input).
  var rows = document.querySelectorAll('cart-drawer-items .cart-item, cart-items .cart-item');
  var paidQty = 0;
  rows.forEach(function (r) {
    if (r.classList.contains('tsc-free-item')) return;
    var inp = r.querySelector('.quantity__input');
    if (inp) paidQty += (parseInt(inp.value, 10) || 0);
  });
  if (paidQty >= 2) {
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    fetch('/cart.js').then(function (r) { return r.json(); }).then(tscEnforceB2G1);
  }
}, true);

// Poll cart after any /cart/add form submission (covers product-page ATC,
// which doesn't dispatch our 'cart:updated' event by default).
function tscPollCart() {
  fetch('/cart.js').then(function (r) { return r.json(); }).then(tscEnforceB2G1).catch(function () {});
}
document.addEventListener('submit', function (e) {
  var form = e.target;
  if (!form) return;
  var action = (form.getAttribute('action') || '').toLowerCase();
  if (action.indexOf('/cart/add') !== -1) {
    setTimeout(tscPollCart, 400);
    setTimeout(tscPollCart, 1200);
  }
}, true);

// Also poll on clicks of add-to-cart buttons (covers JS-driven ATC).
document.addEventListener('click', function (e) {
  var el = e.target.closest('button, a, input[type="submit"]');
  if (!el) return;
  var nm = (el.getAttribute('name') || '').toLowerCase();
  var id = (el.id || '').toLowerCase();
  var href = (el.getAttribute('href') || '').toLowerCase();
  if (nm.indexOf('add') !== -1 || id.indexOf('add') !== -1 || href.indexOf('/cart/add') !== -1) {
    setTimeout(tscPollCart, 400);
    setTimeout(tscPollCart, 1200);
  }
}, true);

// Synchronously remember when the customer explicitly removes the FREE line,
// so it is NOT auto-re-added while the cart still qualifies (2+ paid). This
// decline is cleared automatically once paid quantity drops below 2.
document.addEventListener('click', function (e) {
  var rm = e.target.closest('.tsc-free-item cart-remove-button, .tsc-free-item .cart-remove-button');
  if (!rm) return;
  if (__tscPrevCartToken) {
    try { sessionStorage.setItem(tscSuppressKey(__tscPrevCartToken), '1'); } catch (ex) {}
  }
}, true);

/* =========================================================
   TSC fast-path: single-request quantity change in the gifted state.
   When the customer changes the PAID line's quantity while the free gift is
   showing, do ONE /cart/update straight to the final state instead of letting
   Dawn fire a change that Shopify merges and we then have to correct. Removes
   the second round-trip and the confusing intermediate quantity.
   ========================================================= */
function tscDrawerLoading(on) {
  var items = document.querySelector('cart-drawer-items') || document.getElementById('CartDrawer-CartItems');
  if (items) items.classList.toggle('cart__items--disabled', !!on);
  document.querySelectorAll('cart-drawer .loading__spinner').forEach(function (s) {
    s.classList.toggle('hidden', !on);
  });
}

function tscScaleMoney(el, ratio) {
  if (!el) return;
  var txt = el.textContent;
  var m = txt.match(/[\d][\d.,]*/);
  if (!m) return;
  var num = parseFloat(m[0].replace(/,/g, ''));
  if (isNaN(num)) return;
  var scaled = Math.round(num * ratio * 100) / 100;
  var formatted = scaled.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  el.textContent = txt.replace(m[0], formatted);
}

document.addEventListener('change', function (e) {
  var input = e.target;
  if (!input || !input.classList || !input.classList.contains('quantity__input')) return;
  var drawer = input.closest('cart-drawer');
  if (!drawer) return;
  // Only when a free gift is currently showing.
  if (!drawer.querySelectorAll('.cart-item.tsc-free-item').length) return;
  var row = input.closest('.cart-item');
  if (!row || row.classList.contains('tsc-free-item')) return;          // must be a paid row

  // Single-variant gift only. The discount splits paid units across multiple lines at
  // higher quantities, so there can be more than one paid line -- require they all share
  // the changed line's variant; multi-variant carts fall through to the pick-a-gift modal.
  var paidRows = drawer.querySelectorAll('.cart-item:not(.tsc-free-item)');
  var variantId = input.getAttribute('data-quantity-variant-id');
  var sameVariant = true;
  paidRows.forEach(function (r) {
    var inp = r.querySelector('.quantity__input');
    if (inp && inp.getAttribute('data-quantity-variant-id') !== variantId) sameVariant = false;
  });
  if (!sameVariant) return;

  // Intended paid quantity = sum across all paid lines (the changed input already holds its
  // new value). Buy 2 Get 1 -> free = floor(paid / 2). The discount funds floor(total / 3)
  // free units, which equals floor(paid / 2) when total = paid + floor(paid / 2).
  var newTotalPaid = 0, valid = true;
  paidRows.forEach(function (r) {
    var inp = r.querySelector('.quantity__input');
    var v = inp ? parseInt(inp.value, 10) : NaN;
    if (isNaN(v)) valid = false; else newTotalPaid += v;
  });
  if (!valid || newTotalPaid < 0) return;

  // We are handling this -> stop Dawn's default (which would merge then need a 2nd request).
  e.preventDefault();
  e.stopImmediatePropagation();

  var freeTotal = Math.floor(newTotalPaid / 2);

  // Positional updates: paid lines keep their (new) quantities; all free quantity goes on
  // the first free line, any other free lines are zeroed.
  var rows = drawer.querySelectorAll('.cart-item');
  var updates = [], freeAssigned = false;
  rows.forEach(function (r) {
    var m = (r.id || '').match(/(\d+)$/);
    var idx = m ? parseInt(m[1], 10) : (updates.length + 1);
    var val;
    if (r.classList.contains('tsc-free-item')) {
      val = freeAssigned ? 0 : freeTotal;
      freeAssigned = true;
    } else {
      var inp = r.querySelector('.quantity__input');
      val = inp ? (parseInt(inp.value, 10) || 0) : 0;
    }
    updates[idx - 1] = val;
  });
  for (var i = 0; i < updates.length; i++) if (typeof updates[i] === 'undefined') updates[i] = 0;

  // Optimistic UI (instant prices) only for the simple single-paid-line case.
  if (paidRows.length === 1) {
    var oldQty = parseInt(input.getAttribute('value'), 10);
    if (oldQty > 0 && newTotalPaid > 0 && newTotalPaid !== oldQty) {
      var ratio = newTotalPaid / oldQty;
      row.querySelectorAll('.cart-item__totals .price').forEach(function (el) { tscScaleMoney(el, ratio); });
      drawer.querySelectorAll('.totals__total-value, .totals__subtotal-value').forEach(function (el) { tscScaleMoney(el, ratio); });
    }
  }
  if (freeTotal === 0) {
    drawer.querySelectorAll('.cart-item.tsc-free-item').forEach(function (el) { el.style.display = 'none'; });
  } else {
    drawer.querySelectorAll('.cart-item.tsc-free-item .tsc-free-qty__value').forEach(function (el, idx) { el.textContent = idx === 0 ? freeTotal : 0; });
  }

  __tscFreeRemoveInFlight = true;
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
    body: JSON.stringify({
      updates: updates,
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    })
  })
  .then(function (r) { return r.json(); })
  .then(function (result) {
    var cd = document.querySelector('cart-drawer');
    if (cd && typeof cd.renderContents === 'function') cd.renderContents(result);
    if (result && typeof result.item_count === 'number') __tscPrevItemCount = result.item_count;
    updateMilestoneBar(result);
  })
  .catch(function () {})
  .finally(function () { __tscFreeRemoveInFlight = false; });
}, true);

